import ResourcePermission from "../components/permission/ResourcePermission.js";
import PermissionOnResourceError from "../entities/error/PermissionOnResourceError.js";

export default class PermissionRepository {
    #httpClient;
    #endpointUrl;

    /**
     * @param {HttpClient} httpClient
     * @param {string} endpointUrl
     */
    constructor(httpClient, endpointUrl = '/api/permission') {
        this.#httpClient = httpClient;
        this.#endpointUrl = endpointUrl;
    }

    /**
     * @param {string} resourceType
     * @param {string[]} id
     * @return {Promise<ResourcePermission[]>}
     */
    async getResourcePermissions(resourceType, id) {
        const response = await this.#httpClient
            .fetch(`${this.#endpointUrl}?type=${encodeURIComponent(resourceType)}&ids=${encodeURIComponent(id.join(","))}`, {
                method: 'GET',
                headers: {
                    "Accept": "application/json"
                },
                responseType: 'json'
            });
        assertHasNoErrors(response);
        return ResourcePermission.parseServerJsonMany(response, resourceType);
    }

    /**
     * @param {ResourcePermission[]} resourcePermissions
     * @param {string} actionType is permissions cascades on injections inside of batch {@link PermissionRepository.SAVE_ACTION_TYPE}
     */
    async changeResourcePermissions(resourcePermissions, actionType) {
        await this.#httpClient
            .fetch(`${this.#endpointUrl}?type=${resourcePermissions[0].resourceType}&actOnNested=${actionType}`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json"
                },
                responseType: 'json',
                body: JSON.stringify(resourcePermissions.map(r => r.createServerJson()))
            });
    }

    static SAVE_ACTION_TYPE = {
        SAVE: "NONE",
        SAVE_NESTED: "SHARE"
    }
}

/** @param {{}[]} response */
function assertHasNoErrors(response) {
    const objWithError = response.find(obj => obj.error != null);
    if (objWithError)
        throw PermissionOnResourceError.parseServerJson(objWithError);
}